export const UPDATE_LOAN = "updateLoan";
export function updateLoan(newLoan) {
	return {
		type: UPDATE_LOAN,
		payload: newLoan,
	};
}
